import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import Select from 'react-select';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import {
  Group,
  DateRange,
  Update,
  Face,
  Bookmarks,
  Check,
  Close,
  HourglassEmpty,
  AccessTime, 
  DoneAll,
  Search,
} from '@material-ui/icons';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Table from "beaktShared/components/Table/Table.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import moment from "moment";
import { formateDate} from "beaktShared/helpers/masks";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Button from "beaktShared/components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const classes = useStyles();
  const { register, errors, setError, clearError, getValues, setValue } = useForm({ mode: "onBlur" });
  
  const [notification, setNotification] = React.useState(false);
  const [colorNotification, setColorNotification] = React.useState('info');    
  const [mensagemNotification, setMensagemNotification] = React.useState(false);
  const showNotification = (mensagem,color) => { 
    setMensagemNotification(mensagem);
    setColorNotification(color);      
    setNotification(true);
    setTimeout(function() {
        setNotification(false);
    }, 6000);       
  };

  useEffect(() => {
    verifyAcess();
  }, []);

  const [isLoadingtotalAgendamento, setisLoadingtotalAgendamento] = React.useState(false);
  const [totalizadorAg, settotalizadorAg] = React.useState([]);
  const loadAgbyDate = () =>{       
      var date = new Date(); 
      date = moment(date).format();
      if (session.estabelecimentoId !== 0)
      {
        const endPoint = "agendamentos/totalagendamentobydate/"+date+"/"+session.estabelecimentoId;
        setisLoadingtotalAgendamento(true);
        UseGetApiSimple(endPoint,0).then(result=>{        
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setisLoadingtotalAgendamento(false);
                return false; 
            }             
            settotalizadorAg(result.data);
            setisLoadingtotalAgendamento(false);
            return true;                
        });
      }
      else
      {
        let obj = {
            dataAgenda: date,
            estabelecimentos: estabelecimentos
        }
        setisLoadingtotalAgendamento(true);
        var endPoint = "agendamentos/dashboardAgendaTotal";
        UsePostApi(endPoint, obj).then(result => {
          if (result.status !== 200) {
              showNotification(result.message, 'danger');
              setisLoadingtotalAgendamento(false);
              return false;
          }
          settotalizadorAg(result.data);
          setisLoadingtotalAgendamento(false);
          return true;   
        });
      }
  };

  const [isLoadingProximos10, setisLoadingProximos10] = React.useState(false);
  const [listProximos10, setlistProximos10] = React.useState([]);
  const loadProximos10Agendamentos = () => {
    if (session.estabelecimentoId !== 0) 
    {
      var endPoint = "agendamentos/proximos10/"+session.estabelecimentoId;
      setisLoadingProximos10(true);
      UseGetApiSimple(endPoint,0).then(result=>{         
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProximos10(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
          var datahora = formateDate(item.data)
          datahora = datahora +" - "+ item.horaInicio
          var ag = [
              item.nomeCliente,
              item.descricaoServico,
              datahora                    
          ]
          lstdata.push(ag);
        })
      
        setlistProximos10(lstdata);
        setisLoadingProximos10(false);
        return true;
      });
    }
    else 
    {
      var endPoint = "agendamentos/dashboardProximos10Agendamenos";
      UsePostApi(endPoint, estabelecimentos).then(result => {
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProximos10(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
          var datahora = formateDate(item.data)
          datahora = datahora +" - "+ item.horaInicio
          var ag = [
              item.nomeCliente,
              item.descricaoServico,
              datahora                    
          ]
          lstdata.push(ag);
        })
      
        setlistProximos10(lstdata);
        setisLoadingProximos10(false);
        return true;
      });
    }
  };
  
  const [isLoadingProfixAgend, setisLoadingProfixAgend] = React.useState(false);
  const [listProfixAgend, setlistProfixAgend] = React.useState([]);
  const loadProfissionaisxAg = () => {
    if (session.estabelecimentoId !== 0) 
    {
      var endPoint = "agendamentos/profissionaisxAg/"+session.estabelecimentoId;
      setisLoadingProfixAgend(true);
      UseGetApiSimple(endPoint,0).then(result=>{         
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProfixAgend(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
            
            var row = [
                item.profissionalNome,
                "Total: "+item.totalAgendamento,  
                "Confirmado: "+item.totalConfirmado,
                "Pendente: "+item.totalPendente, 
                "Cancelado: "+item.totalCancelado,          
            ]
            lstdata.push(row);
        })
      
        setlistProfixAgend(lstdata);
        setisLoadingProfixAgend(false);
        return true;                
      });
    }
    else
    {
      setisLoadingProfixAgend(true);
      var endPoint = "agendamentos/dashboardAgendaProfissionais";
      UsePostApi(endPoint, estabelecimentos).then(result => {
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProfixAgend(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
            
            var row = [
                item.profissionalNome,
                "Total: "+item.totalAgendamento,  
                "Confirmado: "+item.totalConfirmado,
                "Pendente: "+item.totalPendente, 
                "Cancelado: "+item.totalCancelado,          
            ]
            lstdata.push(row);
        })
        setlistProfixAgend(lstdata);
        setisLoadingProfixAgend(false);
        return true;
      });
    }
  };

  const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
  const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
  const [estabelecimentos, setestabelecimentos] = React.useState([]);
  const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
  const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
  
  const verifyAcess = () => {
    if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
    else //Acessando tela pelo modulo Clinica
    {
        setestabelecimentos([session.estabelecimentoId]);
        setshowSelectEstabelecimentos(false)
        loadAgbyDate(); 
        loadProximos10Agendamentos(); 
        loadProfissionaisxAg();
    }
  };

  const LoadEstabelecimentos = () => {
      setisLoadingEstabelecimento(true);
      const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
      UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
          showNotification(result.message, 'error')
          setisLoadingEstabelecimento(false);
          return false;
      }

      setisLoadingEstabelecimento(false);
      setlistSelectEstabelecimentos(result.data);
      
      return true;
      });
  };
  
  const handleEstabelecimentoChange = event => {
    let value = event;
    let lstsAdd = [];
    let lstSelect = [];
    value.map(item => {
        lstsAdd.push(item.estabelecimentoId);

        lstSelect.push({
            estabelecimentoId: item.estabelecimentoId
        });
    });
    setestabelecimentos(lstsAdd);
    setlistSelectEstabelecimentosSelected(lstSelect);
  };

  const handleClickSelecionarTodosEstabelecimentos = () => {
    let lstsAdd = [];
    let lstSelect = [];
    listSelectEstabelecimentos.map(item => {
        lstsAdd.push(item.estabelecimentoId);

        lstSelect.push({
            estabelecimentoId: item.estabelecimentoId
        });
    });
    setestabelecimentos(lstsAdd);
    setlistSelectEstabelecimentosSelected(lstSelect);
    
  };
  
  const handleClickPesquisa = () => {
    if (estabelecimentos.length === 0)
    {
      showNotification(t('label.select_an_establishment'), 'danger')
      return false;
    } 
    else 
    {
      loadAgbyDate(); 
      loadProximos10Agendamentos(); 
      loadProfissionaisxAg();
    }
  };

  return (
    <GridItem>

      <Snackbar
          place="tr"
          color={colorNotification}
          message={mensagemNotification}
          open={notification}
          closeNotification={() => setNotification(false)}
          close
      />

      {
          showSelectEstabelecimentos &&
          <div style={{paddingBottom: '25px'}}>
              <Card>
                  <CardHeader color="primary" icon>
                      <CardIcon color="primary">
                          <Search/>
                      </CardIcon>
                      <h4 className={classes.cardIconTitle}>{t('agenda.search_establishment')}</h4>
                  </CardHeader>
                  <CardBody style={{ overflow: "visible", position: "relative", zIndex: 1 }}>
                      <GridContainer>
                          <GridItem xs={12} sm={10} md={10}>                
                              <FormControl fullWidth className={classes.formControl} style={{ marginBottom: '20px' }}>
                                <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishment') + " *"} </label>
                                <Select
                                    menuPortalTarget={document.body}
                                    classNamePrefix="select"
                                    styles={{
                                      ...ValidSelect(errors.estabelecimentos ? true : false),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    isMulti={true}
                                    isLoading={isLoadingEstabelecimento}
                                    name="estabelecimento"
                                    placeholder="Selecione..."
                                    options={listSelectEstabelecimentos}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}
                                    ref={() => register({ name: "estabelecimento" })}
                                />
                                {
                                  errors.estabelecimentos &&
                                  <FormHelperText>
                                      <span className="obg">{t('label.select_an_establishment')} </span>
                                  </FormHelperText>
                                }
                                <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                    <a href="#" onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{ marginTop: '10px' }}>
                                        {t('label.select_all_establishments')}
                                    </a>
                                </div>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={6} md={2}>
                              <Button round color="primary"
                                  onClick={e => { handleClickPesquisa() }}>
                                  {t('label.search')}
                              </Button>
                          </GridItem>
                      </GridContainer>
                  </CardBody>
              </Card>
          </div>
      }
      
      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Bookmarks/>
              </CardIcon>
              <p className={classes.cardCategory}>{t('information_message.schedules_of_the_day')} </p>
              <h3 className={classes.cardTitle}>
                {!isLoadingtotalAgendamento && totalizadorAg.total} 
              </h3>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                {(() => {
                  const hoje = new Date();
                  const dia = String(hoje.getDate()).padStart(2, "0");
                  const mes = String(hoje.getMonth() + 1).padStart(2, "0");
                  const ano = hoje.getFullYear();
                  return `${dia}/${mes}/${ano}`;
                })()}
                <a 
                  style={{display: 'none'}}
                  href="#pablo" 
                  onClick={e => e.preventDefault()}>
                  {t('label.View_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <HourglassEmpty/>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.pending_scheduling')} </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px' 
              }}>
                <h3 className={classes.cardTitle} style={{ margin: 0 }}>
                  {!isLoadingtotalAgendamento && totalizadorAg?.totalPendente}
                </h3>
                {!isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalPendente != null && (
                  <span className={classes.cardCategory} style={{ paddingTop: '6px' }}>
                    / {totalizadorAg.porcentagemTotalPendente.toFixed(2).replace('.', ',')}%
                  </span>
                )}
              </div>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Check />
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.confirmed_schedules')} </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px' 
              }}>
                <h3 className={classes.cardTitle} style={{ margin: 0 }}>
                  {!isLoadingtotalAgendamento && totalizadorAg.totalConfirmado}
                </h3>
                {!isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalConfirmado != null && (
                  <span className={classes.cardCategory} style={{ paddingTop: '6px' }}>
                    / {totalizadorAg.porcentagemTotalConfirmado.toFixed(2).replace('.', ',')}%
                  </span>
                )}
              </div>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader
              color="danger"
              stats
              icon
              className={
                !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalCancelado != null
                  ? classes.cardHeaderFix
                  : undefined
              }
            >
              <CardIcon color="danger">
                <Close/>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.schedules_canceled')} </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px' 
              }}>
                <h3 className={classes.cardTitle} style={{ margin: 0 }}>
                  {!isLoadingtotalAgendamento && totalizadorAg?.totalCancelado}
                </h3>
                {!isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalCancelado != null && (
                  <span className={classes.cardCategory} style={{ paddingTop: '6px' }}>
                    / {totalizadorAg.porcentagemTotalCancelado.toFixed(2).replace('.', ',')}%
                  </span>
                )}
              </div>
              <div style={{
                display: 'inline-flex',
                paddingTop: '10px',
              }}>
                {
                  !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalCancelado != null && (
                  <span 
                    className={classes.cardCategory} 
                    style={{ fontSize: '13px'  }}>
                    cancelado = (cancelado + faltou + removido)
                  </span>
                )}
              </div>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter
              stats
              style={{
                marginTop:
                  !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalCancelado != null
                    ? "0"
                    : undefined
              }}
            >
              <div className={classes.stats}>
                <Update />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader color="naval" stats icon>
              <CardIcon color="naval">
                <AccessTime/>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.attended_scheduling')} </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px' 
              }}>
                <h3 className={classes.cardTitle} style={{ margin: 0 }}>
                  {!isLoadingtotalAgendamento && totalizadorAg?.totalComparecimento}
                </h3>
                {!isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalComparecimento != null && (
                  <span className={classes.cardCategory} style={{ paddingTop: '6px' }}>
                    / {totalizadorAg.porcentagemTotalComparecimento.toFixed(2).replace('.', ',')}%
                  </span>
                )}
              </div>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4}>
          <Card>
            <CardHeader
              color="jade"
              stats
              icon
              className={
                !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalComprou != null
                  ? classes.cardHeaderFix
                  : undefined
              }
            >
              <CardIcon color="jade">
                <DoneAll/>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.converted_sale')} </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px' 
              }}>
                <h3 className={classes.cardTitle} style={{ margin: 0 }}>
                  {!isLoadingtotalAgendamento && totalizadorAg?.totalComprou}
                </h3>
                {!isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalComprou != null && (
                  <span className={classes.cardCategory} style={{ paddingTop: '6px' }}>
                    / {totalizadorAg.porcentagemTotalComprou.toFixed(2).replace('.', ',')}%
                  </span>
                )}
              </div>
              <div style={{
                display: 'inline-flex',
                paddingTop: '10px',
              }}>
                {
                  !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalComprou != null && (
                  <span 
                    className={classes.cardCategory} 
                    style={{ fontSize: '13px'  }}>
                    agendamentos dia / (vendas * 100)
                  </span>
                )}
              </div>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter
              stats
              style={{
                marginTop:
                  !isLoadingtotalAgendamento && totalizadorAg?.porcentagemTotalComprou != null
                    ? "0"
                    : undefined
              }}
            >
              <div className={classes.stats}>
                <Update />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ marginTop: '25px' }}>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Group />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('agenda.next_10_appointments')}
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={12} sm={12} md={12}>
                  <Table
                    tableHead={[t('label.client'), t('label.service'), t('label.date')+"-"+t('label.time')]}
                    tableData={listProximos10}
                  />
                  {isLoadingProximos10 && <div>{t('label.loading')} ...</div>}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Face />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('label.professional')} x {t('agenda.appointments')}
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={12} sm={12} md={12}>
                  <Table
                    tableHead={[t('label.professional'), t('label.total'), t('agenda.confirmed'), t('label.pending'), t('agenda.canceled')]}
                    tableData={listProfixAgend}
                  />
                  {isLoadingProfixAgend && <div>{t('label.loading')}...</div>}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      
    </GridItem>
  );
}

/*

Outros graficos para serem populados futuramente

<GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart className={classes.card}>
            <CardHeader color="info" className={classes.cardHeader}>
              <ChartistGraph
                className="ct-chart-white-colors"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Serviços Realizados</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                em relação a semana anterior
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart className={classes.card}>
            <CardHeader color="primary" className={classes.cardHeader}>
              <ChartistGraph
                className="ct-chart-white-colors"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Frequência de Clientes no Ano</h4>
              <p className={classes.cardCategory}>
                <span className={classes.dangerText}>
                  <ArrowDownward className={classes.upArrowCardCategory} /> 25%
                </span>{" "}
                em relação ao mês anterior
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      */
